
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import echarts from 'echarts'

@Component({
  name: 'detail',
  filters: {
    formatDate: function(value, type) {
      if (!value) {
        return
      }
      let date = new Date(value * 1000)
      let y: any = date.getFullYear()
      let MM: any = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d: any = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h: any = date.getHours()
      let next_h = h < 10 ? ('0' + (h + 1)) : (h + 1)
      h = h < 10 ? ('0' + h) : h
      let m: any = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s: any = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      if (type == 1) {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + '-' + next_h + ':' + m
      } else if (type == 2) {
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m
      }
    }
  },
  components: {}
})
export default class extends Vue {
  @Prop() is_show_employee_info: boolean
  @Prop() employee_info_id: string
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  list: any = []
  employee_id: any = ''
  allData: any = {}
  student_level: any = []
  student_ages: any = []
  p_hight: any = window.innerHeight - 100 + 'px'

  @Watch('is_show_employee_info')
  getId(newVal, oldVal){
    this.employee_id = this.employee_info_id
    this.getList()
    this.getHeight()
  }
  close() {
    this.$emit('close-employee', false)
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }

  async getList() {
    const res: any = await CourseModule.employeeDetail({ employee_id: this.employee_id })
    if (res.code === 200) {
      this.student_level = res.data.student_level
      this.student_ages = res.data.student_ages
      this.list = []
      this.allData = res.data
      this.list.push(res.data)
      this.drawLine()
      this.drawLine1()
    }
  }

  drawLine() {
    // 基于准备好的dom，初始化echarts实例
    let dom:any = document.getElementById('myChart')
    let myChart = echarts.init(dom)
    let showList = []
    let dataList = []
    for (var i = 0; i < this.student_level.length; i++) {
      showList.push(this.student_level[i].level_name)
      dataList.push({ value: this.student_level[i].ratio * 100, name: this.student_level[i].level_name })
    }
    // 绘制图表
    myChart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        left: 0,
        data: showList
      },
      series: [
        {
          name: '学员等级',
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '50%'],

          label: {
            position: 'inner'
          },
          labelLine: {
            show: false
          },
          data: dataList
        }
      ]
    })
  }

  drawLine1() {
    // 基于准备好的dom，初始化echarts实例
    let dom:any = document.getElementById('myChart1')
    let myChart = echarts.init(dom)
    let list = []
    let ages1: any = this.student_ages.find(function(element) {
      return element['ages'] === 1
    })
    let ages2: any = this.student_ages.find(function(element) {
      return element['ages'] === 2
    })
    let ages3: any = this.student_ages.find(function(element) {
      return element['ages'] === 3
    })
    if (ages1) {
      list[0] = ages1['ages']
    } else {
      list[0] = 0
    }
    if (ages2) {
      list[1] = ages2['ages']
    } else {
      list[1] = 0
    }
    if (ages3) {
      list[2] = ages3['ages']
    } else {
      list[2] = 0
    }
    // 绘制图表
    myChart.setOption({
      title: {
        text: '学员上课时间段分布',
        textStyle: {
          // 文字颜色
          color: '#333',
          // 字体风格,'normal','italic','oblique'
          // fontStyle: 'normal',
          // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
          // fontWeight: '400',
          // 字体大小
          // fontSize: 16
        }
      },
      color: ['#3398DB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: ['成人', '儿童', '学生'],
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '人数',
          type: 'bar',
          barWidth: '20%',
          data: list
        }
      ]
    })
  }
  async setOption(val) {
    const data = [{
      field_name: "teacher", 
      search_type: 0, 
      table_name: "", 
      value: [ val.id ]
    }]
    const page_key = 'edu-material-page'
    const res: any = await CourseModule.setHistory({data: data, page_key: page_key})
    if(res.code === 200) {
      this.$router.push({path: '/teaching/material'})
    }
  }
  goMaterialDeatils(val) {
    this.setOption(val)
  }

  mounted() {
    
  }
}
